import React from 'react';
import normalizeVariables from '../../graphql/schema/normalizeVariables';
import getIn from '../../components/connectedForm/utils/getIn';
import { serviceActions } from '../../state/modules/service';
import { getActionProps } from '../../utils/getActionProps';
import { useActionProps } from '../../utils/useActionProps';

export function alertError(title, message, type, dispatch) {
  dispatch(serviceActions.genericAlert(title, message, type));
}

/**
 * Get mutation props for a new Document.
 * @param state - Form/Workspace State.
 * @param props - Form/Workspace Props.
 * @param defaultMutationProps - Set of props similar across all documents (Output type, printer, etc..)
 * @param valueKey - Type of entity we're fetching from props.
 * @returns {{clientMutationId: string, reportParameters: {emailFrom: string, emailToList: *, template: {id: *}, outputType: *, printerId: *, jasperValues: {message: string}}, salesOrder}}
 */
export function getMutationProps(state, props, defaultMutationProps, valueKey = 'salesOrder') {
  //Sanitize the sales order - This is because we have the mutated version from salesOrderUpdate.

  const entityValue = props[valueKey] ? props[valueKey] : normalizeVariables(getIn(props, 'values'));
  if (entityValue?.entityMetaData) delete entityValue.entityMetaData;
  if (entityValue) {
    defaultMutationProps[valueKey] = entityValue;
  }
  return defaultMutationProps;
}

export function getRangeMutationProps(
  state,
  props,
  defaultMutationProps,
  type,
  workspaceUrl = 'Sales/Order/Workspace'
) {
  const { overrideActionProps } = props;
  const actionProps = overrideActionProps?.() || getActionProps(props, type, workspaceUrl);

  return {
    ...defaultMutationProps,
    ...actionProps,
    reportParameters: {
      ...defaultMutationProps.reportParameters,
      overrideOutput: state.overrideOutput,
      overrideTemplate: state.overrideTemplate,
    },
  };
}

export const useRangeMutationProps = (
  state,
  { overrideActionProps, additionalInputVariables = {} },
  defaultMutationProps,
  type
) => {
  const actionProps = useActionProps(type);

  return {
    ...defaultMutationProps,
    ...(overrideActionProps?.() || actionProps),
    reportParameters: {
      ...defaultMutationProps.reportParameters,
      overrideOutput: state.overrideOutput,
      overrideTemplate: state.overrideTemplate,
    },
    ...additionalInputVariables,
  };
};
